import React from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { client } from 'src/utils/api-client';
import { StyledButton, StyledButtonBox } from '../index.styles';

export default function NotAClient() {
  const { t } = useTranslation();

  const redirectToBnp = useMutation({
    mutationFn: () => client.post('/web/events/redirect_to_bnp'),
    onSettled: () => {
      window.location.href =
        'https://www.bnpparibas.pl/male-firmy/pakiety-i-rachunki/konto-firmowe';
    },
  });

  const redirectToInfo = useMutation({
    mutationFn: () => client.post('/web/events/redirect_to_bnp'),
    onSettled: () => {
      window.location.href =
        'https://www.bnpparibas.pl/przedsiebiorstwa/obsluga-biezaca/plany-taryfowe-rachunki';
    },
  });

  return (
    <div>
          <StyledButtonBox sx={{ justifyContent: 'center' }}>
      <StyledButton
        variant="contained"
        size="large"
        onClick={() => redirectToBnp.mutate()}
      >
        {t('registration_bnp:becomeClient')}
      </StyledButton>
    </StyledButtonBox>
    <StyledButtonBox sx={{ justifyContent: 'center' }}>
      <StyledButton
        variant="contained"
        size="large"
        onClick={() => redirectToInfo.mutate()}
      >
        {t('registration_bnp:becomeClientInfo')}
      </StyledButton>
    </StyledButtonBox>
    </div>
  );
}
